/*********************** Custom JS for Boost AI Search & Discovery  ************************/

window.__BoostCustomization__ = (window.__BoostCustomization__ ?? []).concat([
  (componentRegistry) => {
    componentRegistry.useComponentPlugin('ProductTitle', {
    name: 'Modify Component ProductTitle',
    enabled: true,
    apply: () => ({
      afterRender(element) {
        try {
          const productData = element.getParentElm().getParentElm().getParentElm().getParams().props.product
          let productItem = document.querySelector('[data-product-id="'+ productData.id +'"]');
          if (productItem && !productItem.querySelector('.bazaar-voice-reviews')) {
            // productItem.querySelector('.boost-sd__product-title').insertAdjacentHTML('afterend', `<div class="bazaar-voice-reviews" data-bv-show="inline_rating" data-bv-product-id="${productData.id}" data-bv-redirect-url="${productData.handle}" data-bv-seo="false"></div>`)
            productItem.querySelector('.boost-sd__product-title').insertAdjacentHTML('afterend', `<div class="bazaar-voice-reviews" data-bv-show="inline_rating" data-bv-product-id="${productData.id}" data-bv-seo="false"></div>`)
          }

          if (productItem && !productItem.querySelector('.SPCMP_chk_lbl')) {
            var collectionIds = [];
            if(productData?.collections.length){
              productData.collections.forEach(function(collection){
                collectionIds.push(collection.id);
              })
            }
            var collectionString = collectionIds.length ? collectionIds.toString() : '';
            productItem.querySelector('.boost-sd__product-link').insertAdjacentHTML('afterend', `<label class="SPCMP_chk_lbl" style="display:none;"><input type="checkbox" class="SPCMP_Add " name='SPCMP_chk' spcmp_collids="${collectionString}" spcmp_pid="${productData.id}" spcmp_vid="${productData.variants[0].id}"><span class="SPCMP_Add_span"></span></label>`);
          }
        } catch (error) {
          console.log(error)
        }
      },
    }),
  });
},
  

(componentRegistry) => {
    let preventReCallProductHandlesTheSame = [];
    componentRegistry.useComponentPlugin('ProductList', {
      name: 'Product List After Render',
      enabled: true,
      apply: () => ({
        afterRender(element){
          const helpersRef = element.getHelpers();
          const productHandles = helpersRef.getProductHandles();
          const isDuplicate = JSON.stringify(preventReCallProductHandlesTheSame) === JSON.stringify(productHandles);
          preventReCallProductHandlesTheSame = productHandles;
          
          productHandles?.length && !isDuplicate && typeof reinitializeCompare() != "undefined" && reinitializeCompare();
        }
      })
    })
  }

]);

function waitForElm(selector) {
    return new Promise(resolve => {
        var isStop = false;
        setTimeout(function () {
            isStop = true;
        }, 10000)
        if (document.querySelector(selector)) {
            return resolve(document.querySelector(selector));
        }

        const observer = new MutationObserver(mutations => {
            console.log('isStop: ', isStop);
            if (document.querySelector(selector)) {
                observer.disconnect();
                resolve(document.querySelector(selector));
            }
            if (isStop && !document.querySelector(selector)) {
                observer.disconnect();
                resolve(null);
            }
        });

        // If you get "parameter 1 is not of type 'Node'" error, see https://stackoverflow.com/a/77855838/492336
        observer.observe(document.body, {
            childList: true,
            subtree: true
        });
    });
}
const formatMoney = (money, format, withoutTrailingZeros) => {
  if (typeof format == "undefined") format = boostSDAppConfig.shop.money_format;
  if (format == "money_with_currency") format = boostSDAppConfig.shop.money_format_with_currency;
  if (typeof withoutTrailingZeros == "undefined") var withoutTrailingZeros = true;
  // if (typeof Shopify.formatMoney === 'function') { return Shopify.formatMoney(money, format); }
  if (typeof money == "string") {
    money = money.replace(".", "");
  }
  var value = "";
  var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  var formatString = format || "${{amount}}";

  function defaultOption(opt, def) {
    return typeof opt == "undefined" ? def : opt;
  }

  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultOption(precision, 2);
    thousands = defaultOption(thousands, ",");
    decimal = defaultOption(decimal, ".");
    if (isNaN(number) || number == null) {
      return 0;
    }
    number = parseFloat(number).toFixed(precision);
    var parts = number.split(".");
    var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + thousands);
    var money = parts[1] ? decimal + parts[1] : "";
    return withoutTrailingZeros == true ? (dollars + money).replace(/((\,00)|(\.00))$/g, "") : dollars + money;
  }

  var matches = formatString.match(placeholderRegex);
  var match = matches && matches.length > 1 ? matches[1] : "";
  switch (match) {
    case "amount":
      value = formatWithDelimiters(money, 2);
      break;
    case "amount_no_decimals":
      value = formatWithDelimiters(money, 0);
      break;
    case "amount_with_comma_separator":
      value = formatWithDelimiters(money, 2, ".", ",");
      break;
    case "amount_no_decimals_with_comma_separator":
      value = formatWithDelimiters(money, 0, ".", ",");
      break;
    case "amount_with_space_separator_no_comma":
      value = formatWithDelimiters(money, 2);
      break;
    case "amount_no_decimals_with_space_separator":
      value = formatWithDelimiters(money, 0, " ", ".");
      break;
    default:
      value = formatWithDelimiters(money, 2);
      break;
  }
  formatString = formatString.replace(placeholderRegex, value);

  return formatString;
};

const customize = {
   updateProductItemISW: (componentRegistry) => {
      componentRegistry.useComponentPlugin('SearchProductItem', {
         name: 'Customize product item ISW',
         enabled: true,
         apply: () => ({
            afterRender(element) {
               try {
                  // Start customization--------------------------------------------
                  let productData = element.getParams().props.product;
                  let productId = productData.id;
                  if (productData?.split_product) {
                     productId = productData.variant_id;
                  }
                  if (productData.price_min < productData.price_max) {
                    let productPriceItem = document.querySelector('.boost-sd__suggestion-queries-item--product[data-id="' + productId + '"] .boost-sd__suggestion-queries-item-price');
                    if (productPriceItem) {
                       /* use pure js here */
                      let newPriceHtml = `
                        <span class="boost-sd__suggestion-queries-item-amount boost-sd__suggestion-queries-item-amount--regular">
                          <span class="boost-sd__format-currency">
                            <span class="">${formatMoney(productData.price_min)} - ${formatMoney(productData.price_max)}</span>
                          </span>
                        </span>
                      `;
                      productPriceItem.innerHTML = newPriceHtml;
                    }
                  }
                  // End-------------------------------------------------------------
               } catch (e) {
                  console.warn(e);
               }
            }
         }),
      });
   }
}

window.__BoostCustomization__ = (window.__BoostCustomization__ ?? []).concat([customize.updateProductItemISW]);


const customize2 = {
   updateProductItemGrid: (componentRegistry) => {
      componentRegistry.useComponentPlugin('ProductItem', {
         name: 'Add extra information',
         enabled: true,
         apply: () => ({
            afterRender(element) {
               try {
                  // Start customization--------------------------------------------
                  let productData = element.getParams().props.product;
                  let productId = productData.id;
                  if (productData?.split_product) {
                     productId = productData.variant_id;
                  }
                  if (productData.price_min < productData.price_max) {
                    let productPriceItem = document.querySelector('.boost-sd__product-item[data-product-id="' + productId + '"] .boost-sd__product-price-content');
                    if (productPriceItem) {
                       /* use pure js here */
                      let newPriceHtml = `
                          <span class="boost-sd__format-currency">
                            <span class="">${formatMoney(productData.price_min)} - ${formatMoney(productData.price_max)}</span>
                          </span>
                      `;
                      productPriceItem.innerHTML = newPriceHtml;
                    }
                  }
                  // End-------------------------------------------------------------
               } catch (e) {
                  console.warn(e);
               }
            }
         }),
      });
   }
}

window.__BoostCustomization__ = (window.__BoostCustomization__ ?? []).concat([customize2.updateProductItemGrid]);